export default [
  {
    path: "/restrictions",
    name: "restrictions",
    component: () =>
      import(
        /* webpackChunkName: "restrictions" */ "@/views/admin/Restrictions.vue"
      ),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/device-command-history",
    name: "device-command-history",
    component: () =>
      import(
        /* webpackChunkName: "restrictions-history" */ "@/views/admin/DeviceCommandHistory.vue"
      ),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/restrictions-history",
    name: "restrictions-history",
    component: () =>
      import(
        /* webpackChunkName: "restrictions-history" */ "@/views/admin/RestrictionsHistory.vue"
      ),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/restrictions-history-filter",
    name: "restrictions-history-filter",
    component: () =>
      import(
        /* webpackChunkName: "restrictions-history-filter" */ "@/views/admin/RestrictionsHistoryFilter.vue"
      ),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/station-create",
    name: "station-create",
    component: () =>
      import(
        /* webpackChunkName: "station-create" */ "@/views/admin/StationSave.vue"
      ),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/station-edit/:id",
    name: "station-edit",
    component: () =>
      import(
        /* webpackChunkName: "station-edit" */ "@/views/admin/StationSave.vue"
      ),
    meta: { requiresAuth: true }
  },
  {
    path: "/users",
    name: "users",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/views/admin/Users.vue"),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/user-edit/:id",
    name: "user-edit",
    component: () =>
      import(/* webpackChunkName: "user-edit" */ "@/views/admin/UserSave.vue"),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  },
  {
    path: "/user-create",
    name: "user-create",
    component: () =>
      import(
        /* webpackChunkName: "user-create" */ "@/views/admin/UserSave.vue"
      ),
    meta: {
      requiresAuth: true,
      noMenu: true
    }
  }
];
